import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { LocLabel } from '../../components/clickable-row-table/models/data-table-config.models';

interface FormSectionOptionFlags {
  required: boolean;
  showDivider: boolean;
  withPadding: boolean;
}

export type FormSectionOptions = 'default' | 'req' | 'noDiv' | 'pad';

@Component({
  selector: 'app-form-section',
  templateUrl: './form-section.component.html',
  styleUrls: ['./form-section.component.scss']
})
export class FormSectionComponent implements OnChanges {
  @Input() headerKey?: string | LocLabel | null;
  @Input() extraDataKey?: string | LocLabel | null;
  @Input() sectionOptions: FormSectionOptions[] = ['default'];

  public optionsFlags: FormSectionOptionFlags = { required: false, showDivider: true, withPadding: false };

  constructor(public rwdService: RWDService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sectionOptions) {
      const val = changes.sectionOptions.currentValue;
      this.optionsFlags = { required: false, showDivider: true, withPadding: false };
      if (val.includes('req')) this.optionsFlags.required = true;
      if (val.includes('noDiv')) this.optionsFlags.showDivider = false;
      if (val.includes('pad')) this.optionsFlags.withPadding = true;
    }
  }
}
